"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _changeLanguage = require("./changeLanguage");
Object.keys(_changeLanguage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changeLanguage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changeLanguage[key];
    }
  });
});
var _ensureEndsWith = require("./ensureEndsWith");
Object.keys(_ensureEndsWith).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ensureEndsWith[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ensureEndsWith[key];
    }
  });
});
var _getDefaultIsOpenedState = require("./getDefaultIsOpenedState");
Object.keys(_getDefaultIsOpenedState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDefaultIsOpenedState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getDefaultIsOpenedState[key];
    }
  });
});
var _getLanguageCodeAbbreviation = require("./getLanguageCodeAbbreviation");
Object.keys(_getLanguageCodeAbbreviation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getLanguageCodeAbbreviation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getLanguageCodeAbbreviation[key];
    }
  });
});
var _getLanguageCookieValue = require("./getLanguageCookieValue");
Object.keys(_getLanguageCookieValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getLanguageCookieValue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getLanguageCookieValue[key];
    }
  });
});
var _getLegacyCookieName = require("./getLegacyCookieName");
Object.keys(_getLegacyCookieName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getLegacyCookieName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getLegacyCookieName[key];
    }
  });
});
var _getLegacyLanguageCookieValue = require("./getLegacyLanguageCookieValue");
Object.keys(_getLegacyLanguageCookieValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getLegacyLanguageCookieValue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getLegacyLanguageCookieValue[key];
    }
  });
});
var _hasLanguageInUrl = require("./hasLanguageInUrl");
Object.keys(_hasLanguageInUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _hasLanguageInUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _hasLanguageInUrl[key];
    }
  });
});
var _isDefaultLanguage = require("./isDefaultLanguage");
Object.keys(_isDefaultLanguage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isDefaultLanguage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isDefaultLanguage[key];
    }
  });
});
